<template>
  <svg
    width="10"
    height="18"
    viewBox="0 0 10 18"
  >
    <path d="M9.15711 10.0485L9.65295 6.81553H6.55101V4.71751C6.55101 3.83302 6.98431 2.97088 8.37369 2.97088H9.78405V0.218461C9.78405 0.218461 8.50408 0 7.28043 0C4.72563 0 3.05588 1.54835 3.05588 4.35146V6.81553H0.216064V10.0485H3.05588V17.8641C3.62531 17.9535 4.20894 18 4.80346 18C5.39799 18 5.98162 17.9535 6.55101 17.8641V10.0485H9.15711Z" fill="#0F0017"/>
  </svg>
</template>
